import type { OrderCardsParams } from '@/api/cardOrders/types';
import type { CardOrdersResponseType } from '@/api/schema';
import { ADDRESS_TYPE } from '@/components/steps/ShippingAddressStep/shippingSchema';

// Matches an order when the search term is part of one of its card numbers or of the name of the
// person who placed it. Returns every order when the search term is empty.
export const filterOrdersBySearch = (orders: CardOrdersResponseType[], searchTerm: string) => {
    const term = searchTerm.trim().toLowerCase();

    if (!term) {
        return orders;
    }

    return orders.filter(order => {
        const orderedBy = `${order.user?.firstName ?? ''} ${order.user?.lastName ?? ''}`.trim().toLowerCase();

        return order.cards.some(card => card.cardNumber.toLowerCase().includes(term)) || orderedBy.includes(term);
    });
};

export const buildCardOrderRequest = (params: OrderCardsParams) => ({
    shippingAddress: {
        isCompanyAddress: params.isShippingAddressRedesignEnabled
            ? params.shipping?.addressType === ADDRESS_TYPE.company
            : undefined,
        companyName: params.isShippingAddressRedesignEnabled
            ? params.shipping?.addressType === ADDRESS_TYPE.company
                ? params.shipping?.companyName
                : undefined
            : undefined,
        firstAddressLine: params.shipping?.address ?? '',
        secondAddressLine: params.shipping?.address2,
        zip: params.shipping?.postCode ?? '',
        city: params.shipping?.city ?? '',
        countryCode: params.shipping?.country ?? '',
        addressee: params.shipping?.addressee,
    },
    cardDetails:
        params.chargingCards?.cardsListCustomization?.map(c => ({
            firstRow: c.line1,
            secondRow: c.line2,
            productId: 95379,
            supportLabel: params.supportLabel,
            supportPhone: params.supportPhone,
        })) ?? [],
});
